import React from "react";

// value: {messages: [{id, text, type}], addMessage(text, type), removeMessage(id)}
export const ContextMessages = React.createContext(null);
